import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityRolesActividadState
} from './entity-roles-actividad.state';
import { entityRolesActividadAdapter } from './entity-roles-actividad.state';
import {
  entityRolesActividadLoadRequest,
  entityRolesActividadLoadSuccess,
  entityRolesActividadLoadFailure,
  entityRolesActividadAddFailure,
  entityRolesActividadAddRequest,
  entityRolesActividadAddSuccess,
  entityRolesActividadChangeFailure,
  entityRolesActividadChangeRequest,
  entityRolesActividadChangeSuccess,
  entityVinculacionesRolActividadChangeFailure,
  entityVinculacionesRolActividadChangeRequest,
  entityVinculacionesRolActividadChangeSuccess,
  entityRolesActividadDeleteFailure,
  entityRolesActividadDeleteRequest,
  entityRolesActividadDeleteSuccess
} from './entity-roles-actividad.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityRolesActividadLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityRolesActividadLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityRolesActividadLoadSuccess, (state, { items }) =>
    entityRolesActividadAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityRolesActividadAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityRolesActividadAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityRolesActividadAddSuccess, (state, { item }) =>
    entityRolesActividadAdapter.addOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // change
  on(entityRolesActividadChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityRolesActividadChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityRolesActividadChangeSuccess, (state, { item }) =>
    entityRolesActividadAdapter.updateOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // change vinculaciones
  on(entityVinculacionesRolActividadChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityVinculacionesRolActividadChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityVinculacionesRolActividadChangeSuccess, (state, { item }) =>
    entityRolesActividadAdapter.updateMany(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // delete
  on(entityRolesActividadDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityRolesActividadDeleteFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityRolesActividadDeleteSuccess, (state, { item }) =>
    entityRolesActividadAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function rolesActividadReducer(
  state: EntityRolesActividadState | undefined,
  action: Action
) {
  return reducer(state, action);
}
